import React from 'react';
import { API_BASE_URL } from '../config';
import { Archive } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';
import { toast } from '../hooks/use-toast';

const API = API_BASE_URL + '/api';

const ArchiveButton = ({ task, onArchiveComplete, variant = 'ghost' }) => {
  // Guard clause for null task
  if (!task || !task._id) {
    return null;
  }
  
  const handleArchive = async (e) => {
    e.stopPropagation();
    
    const isArchived = task.archived || false;
    
    try {
      await axios.patch(
        `${API}/tasks/${task._id}/archive`,
        { archived: !isArchived },
        { withCredentials: true }
      );
      
      toast({ 
        title: isArchived ? 'Task unarchived' : 'Task archived',
        description: isArchived ? 'Task restored to board' : 'Task moved to archive'
      });
      
      if (onArchiveComplete) {
        onArchiveComplete(task._id, !isArchived);
      }
    } catch (error) {
      console.error('Error archiving task:', error);
      toast({ 
        title: 'Error', 
        description: 'Failed to archive task',
        variant: 'destructive' 
      });
    }
  };

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={handleArchive}
      className="text-gray-600 hover:text-[#1C3E53]"
      title={task.archived ? 'Unarchive task' : 'Archive task'}
    >
      <Archive className="h-4 w-4" />
    </Button>
  );
};

export default ArchiveButton;
